import { createSelector } from 'reselect';
import isPlainObject from 'lodash/isPlainObject';
import { currentUser, authorization, legit } from 'apex-legit-service';
import { REQUIRED_PERMISSIONS } from 'common';
import { selectError as selectSearchServiceError } from 'services/search';
import { selectError as selectActionsServiceError } from 'services/actions';
import { NAMESPACE } from './constants';

const selectCurrentUserService = (state) => state[currentUser.NAMESPACE];
const selectOrgUnits = createSelector(selectCurrentUserService, (service) => service.results || []);
const selectAppNamespace = (state) => state[NAMESPACE];
const selectErrors = createSelector(selectAppNamespace, (app) => app.errors || []);

// User has enough permissions to use the app.
const selectUserHasSufficientPermissions = (state) => {
  const domain = state[authorization.NAMESPACE];

  if (!isPlainObject(domain.results)) return false;
  const missingPermissions = authorization.selectors.getMissingPermissions(domain.results.permissions);
  return !missingPermissions.some((permission) => REQUIRED_PERMISSIONS.includes(permission));
};

const selectShowLoginUI = (state) => {
  const legitShowLoginUI = legit.selectors.selectShowLoginUI(state);
  // Show the login UI if we are not logged in OR if we don't have all required permissions.
  return (
    legitShowLoginUI === legit.LOGIN_UI_SHOW
    ||
    (legitShowLoginUI === legit.LOGIN_UI_HIDE && !selectUserHasSufficientPermissions(state)));
};

const selectShowAppContent = (state) => {
  const legitHideLoginUI = legit.selectors.selectShowLoginUI(state) === legit.LOGIN_UI_HIDE;
  return legitHideLoginUI && selectUserHasSufficientPermissions(state);
};

export {
  selectErrors,
  selectOrgUnits,
  selectSearchServiceError,
  selectActionsServiceError,
  selectCurrentUserService,
  selectAppNamespace,
  selectShowLoginUI,
  selectShowAppContent,
  selectUserHasSufficientPermissions,
};



// WEBPACK FOOTER //
// ./src/containers/App/selectors.js